module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1122.6965fd4d.png";